import { render, staticRenderFns } from "./NewOrderConfirmDialog.vue?vue&type=template&id=e18fc1e2&"
import script from "./NewOrderConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./NewOrderConfirmDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports